export default "__VITE_ASSET__HAFP5EoT__"